import personImage from "../../../common/images/person.svg";
import refreshImage from "../../../common/images/refresh-blue.svg";
import bookImage from "../../../common/images/book.svg";
import { PrimaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { Dispatch } from "redux";
import { format } from "date-fns";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { NavigateFunction } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { handleOnDownloadClick } from "../../../common/utils/handleOnDownloadClick";
import {
    setIsCreateCertificateModalOpen,
    setSelectedEmployee,
    setSelectedQualification,
} from "../../../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { openFileInNewTab } from "../../../common/utils/openFileInNewTab";

interface Props {
    certificates: CertificateInterface[];
    dispatch: Dispatch;
    navigate: NavigateFunction;
    isEstablishmentManager?: boolean;
}

export const getTableRows = (props: Props): PrimaryTableRow[][] => {
    const { certificates, navigate, dispatch, isEstablishmentManager } = props;

    return certificates.map((certificate): PrimaryTableRow[] => {
        const qualification = certificate.qualification;

        return [
            {
                value: qualification.name,
            },
            ...(isEstablishmentManager
                ? [
                      {
                          value:
                              getUserFullName(certificate.employee?.user) ??
                              "-",
                      },
                      {
                          value: qualification.qualification_standards?.length
                              ? qualification.qualification_standards.map(
                                    (qualificationStandard) =>
                                        qualificationStandard.tag,
                                )
                              : "",
                      },
                      {
                          value: certificate.educator?.name ?? "-",
                      },
                  ]
                : []),
            {
                value: certificate?.expires_at
                    ? format(certificate.expires_at, "dd-MM-yyyy")
                    : "",
            },
            {
                value: "",
                actionData: [
                    {
                        title: isEstablishmentManager
                            ? "Certificaat bekijken"
                            : "Certificaat downloaden",
                        iconUrl: bookImage,
                        onClick: () => {
                            if (isEstablishmentManager) {
                                openFileInNewTab(
                                    certificate.certificate_file.file_url,
                                );
                                return;
                            }

                            handleOnDownloadClick(
                                certificate.certificate_file.file_url,
                            ).catch((error) => {
                                console.error(error);
                            });
                        },
                    },
                    ...(isEstablishmentManager
                        ? [
                              {
                                  title: "Medewerker bekijken",
                                  iconUrl: personImage,
                                  onClick: () => {
                                      navigate(
                                          RouteEnum.EMPLOYEES +
                                              `/${certificate.employee.id}`,
                                      );
                                  },
                              },
                          ]
                        : []),
                    {
                        title: "Opnieuw toevoegen",
                        iconUrl: refreshImage,
                        onClick: () => {
                            dispatch(setSelectedEmployee(certificate.employee));
                            dispatch(setSelectedQualification(qualification));
                            dispatch(setIsCreateCertificateModalOpen(true));
                        },
                    },
                ],
            },
        ];
    });
};
